<app-mng-header></app-mng-header>
<section class="container accesibilidad">
  <div class="row">
    <div class="col-12">

      <div class="container comunicaciones bloquePrincipal" role=main>
        <div class="cabeceraPagina">
          <div class="row">
            <div class="col-12">
              <a  class=" btn btn-primary pull-right"  routerLink="../" ><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Volver</a>
            </div>
          </div>
          <h1>Política de Accesibilidad</h1>
          <p>El sitio web https://faceb2b.gov.es/ se ha construido adoptando una serie de medidas con el objetivo de mejorar su accesibilidad y cumplir los preceptos de diseño universa​l.</p>
          <p>FACeB2B trabaja para garantizar que todos los ciudadanos –con especial atención a las personas con algún tipo de discapacidad y mayores-, que se relacionan con ella a través de Internet puedan acceder a la información y los servicios electrónicos en igualdad de condiciones con independencia de sus circunstancias personales, medios o conocimientos.</p>

          <h1>Estándares y normativa</h1>
          <p>Este portal cumple con lo establecido en el Real Decreto 1494/2007, de 12 de noviembre, por el que se aprueba el Reglamento sobre las condiciones básicas para el acceso de las personas con discapacidad a las tecnologías, productos y servicios relacionados con la sociedad de la información y medios de comunicación social.</p>
          <p>Nivel de accesibilidad alcanzado: AA según la Norma UNE 139803:2012 y, por consiguiente, de los requisitos de conformidad del W3C (AA de la norma WCAG 2.0.)</p>
          <p>Fecha última revisión: <b>Enero del 2020</b></p>
          <p>Estos han sido comprobados con un análisis manual de la accesibilidad y través de diferentes herramientas semi-automáticas</p>
          <p>Esto conlleva una serie de ventajas como:</p>
          <div class="checkList">
            <ul>
              <li>Facilitar el acceso de los usuarios independientemente de su condición física o de su entorno.</li>
              <li>Permitir el acceso con diferentes agentes de usuario.</li>
              <li>Incluir contenidos claros bien estructurados.</li>
              <li>Mejorar la navegación y la experiencia del usuario.</li>
              <li>Entre otras se han adoptado las siguientes medidas:
                <div class="checkList">
                  <ul>
                    <li>Uso de CSS para la presentación de la información.</li>
                    <li>Texto alternativo en las imágenes.</li>
                    <li>Los enlaces ofrecen detalles de la función o destino del hipervínculo.</li>
                    <li>Uso de los estándares del W3C.</li>
                    <li>Cumplimiento de los estándares</li>
                  </ul>
                </div>

              </li>
            </ul>
          </div>

          <h2>Compromiso con la accesibilidad</h2>
          <p>A pesar del esfuerzo realizado por FACe, dada la enorme cantidad de documentos finales publicados en este sitio web, ha resultado imposible su adaptación completa a las pautas de accesibilidad exigibles. Si usted encontrara una página o documento que no cumpliera con lo establecido, o al que no pudiera acceder correctamente, o bien deseara formular cualquier queja, consulta o sugerencia, por favor, háganoslo saber mediante la cumplimentación y envío del
            <a href="https://ssweb.seap.minhap.es/ayuda/consulta/CarpetaCiudadana" target="_blank" title="Formulario de incidencia de accesibilidad. (enlace externo)">siguiente formulario de contacto.</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<app-mng-footer></app-mng-footer>



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-accessibility/cli-accessibility.component.html